import { Injectable } from '@angular/core';
import { BasicListModel } from '../../shared/models';
import { AbstractCRUD, ExceptionService, UtilsService } from '../../xform-compat';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CRMItem } from '../../shared/models/crm/CRMItem.model';


@Injectable({
  providedIn: 'root'
})
export class CrmAgendaService extends AbstractCRUD<BasicListModel> {

  constructor(
    exceptionService: ExceptionService,
    http: HttpClient,
    utilsService: UtilsService,
  ) {
    super(exceptionService, http, utilsService);
  }

  public getResourcePath(): string {
    return '/crm/report/meeting/agenda';
  }

  public getAgendaSchedule(): Observable<any> {
    return super.getHTTP().get(`${this.getApiPath()}/delivery`)
    .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  public getAgendaItems(): Observable<any> {
    return super.getHTTP().get(`${this.getApiPath()}/all`)
    .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  public sendAgenda(domainId: number): Observable<any> {
    return super.getHTTP().post(`${this.getApiPath()}/${domainId}`, {})
    .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  public addAgendaItem(crmItem: CRMItem): Observable<any> {
    return super.getHTTP().put(`${this.getApiPath()}/add/${crmItem.id}`, {})
    .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  public removeAgendaItem(crmItem: CRMItem): Observable<any> {
    return super.getHTTP().put(`${this.getApiPath()}/remove/${crmItem.id}`, {})
    .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }
}
